import styled from '@emotion/styled';
import { ui } from '@libs/domain';
import { useItemName } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router';

const LogoContainer = styled.div`
  width: 160px;
  height: 38px;
  grid-column: 1/1;
`;

const Img = styled.img`
  padding-top: 8px;
  padding-left: 16px;
  width: 130px;
  height: 22px;
`;

interface LogoProps {
  homePath?: string;
}

function Logo(props: LogoProps) {
  const { homePath } = props;
  const navigate = useNavigate();
  const getName = useItemName();

  return (
    <LogoContainer
      style={{ cursor: homePath ? 'pointer' : 'auto' }}
      onClick={() => {
        if (homePath) navigate(homePath);
      }}
      title={homePath ? getName(ui.linkNames.toMainMenu) : undefined}
    >
      <Img id="logo" className="logo-image" src="images/proplus_logo.png" alt="ProShip" />
    </LogoContainer>
  );
}

export { Logo };
